import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const PearsonLogo = props => (
  <SvgIcon
    width={43}
    height={48}
    viewBox="0 0 43 48"
    {...props}
  >
    <path
      id="a"
      fill="currentcolor"
      d={
        `M33.192 3.028c9.82 5.662 12.106 18.358 5.273 31.203C32.461 45.523 19.35 50.345 9.58 44.596-.193 38.846-2.1 
        22.808 2.099 13.578 8.197.175 22.342-3.23 33.192 3.028zM19.227 35.981c-.639 0-1.265.356-1.675.953a2.3 2.3 0 0 
        0-.391 1.665c.057.366.193.685.394.922.225.269.569.474.996.597.246.069.5.106.753.106.551 0 1.047-.168 
        1.432-.484.448-.37.692-.896.687-1.482a2.304 2.304 0 0 0-.873-1.775 2.345 2.345 0 0 0-.973-.467 1.835 
        1.835 0 0 0-.35-.035zm13.71-23.24c-3.694-4.221-8.821-4.487-12.069-4.404-3.589.091-6.167 1.29-8.275 
        2.404-1.84.97-3.5 2.64-4.173 3.469-.429.528-1.158 1.62-.768 2.598.324.812 1.533.76 1.988.412.455-.347.936-.874 
        1.561-1.397 2.771-2.32 5.228-3.781 10.952-3.781 5.723 0 8.826 3.612 8.826 6.837 0 3.225-1.506 5.415-4.352 
        6.843-1.41.708-2.915 1.255-4.81 
        1.33.138-3.127.208-6.085.208-6.085.04-2.25.417-4.08-1.071-4.384-1.486-.303-4.223-.004-4.274 1.712-.067-.255.281
        14.067.345 14.35l.025.329c.03.363.157.684.381.938.225.253.588.41.916.447.05.006.101.009.154.009.31 0 .748-.055 
        1.191-.182.557-.16 1.118-.436 1.441-.862.164-.218.299-.427.37-.815.047-.263.143-1.927.167-2.41 3.01-.027 
        6.069-.6 8.397-2.033 2.937-1.809 4.702-4.536 5.084-7.483.334-2.585-.265-5.737-2.187-7.814z`
      }
    />
  </SvgIcon>
);

export default PearsonLogo;
